import React, { PropTypes } from 'react';
import MultiStep from '../../../tc-ui/stepper-wizard';
import AllFourSteps from './all-four-steps-dumb.jsx';
import { connect } from 'react-redux';
import { updateFormData } from '../../../../stores/contracting/add-rates-wizard/rates-wizard-actions';
import actions from '../../../../stores/contracting/root-actions-map';
import { onUserInput } from '../../../../stores/userInputActions';

const AddRateSetStepper = props => {
  const {
    addRateSetStepperComponentIndex,
    goToStep,
    ...extraProps,
    } = props;
  const stepNames = ['Rate Set Info', 'Add Rates', 'Review & Add'];
  const feedAllFourSteps = {
    ...extraProps,
    goToNextStep: (componentIndex) => goToStep({ stepperWizardName: 'addRateSetStepper', componentIndex: componentIndex + 1 }),
    goToPreviousStep: (componentIndex) => goToStep({ stepperWizardName: 'addRateSetStepper', componentIndex: componentIndex - 1 }),
  }
  return (
    <MultiStep
      steps={stepNames}
      componentIndex={addRateSetStepperComponentIndex}
      showStepsBar
    >
      <AllFourSteps {...feedAllFourSteps} index={0}/>
      <AllFourSteps {...feedAllFourSteps} index={1}/>
      <AllFourSteps {...feedAllFourSteps} index={2}/>
    </MultiStep>);
};

AddRateSetStepper.propTypes = {
  addRateSetStepperComponentIndex: PropTypes.number,
  fieldValues: PropTypes.object,
  updateFieldValue: PropTypes.func,
  updateDaysOfWeek: PropTypes.func,
  updateRatesTableCell: PropTypes.func,
  calculateRatesTable: PropTypes.func,
  goToStep: PropTypes.func,
  onFinish: PropTypes.func,
  cancelFunc: PropTypes.func,
  showStepOneBack: PropTypes.bool,
  stepOneBackFunc: PropTypes.func,
  step3ContinueText: PropTypes.string,
  cancelText: PropTypes.string,
  usedRateSetNamesAndCodes: PropTypes.array,
  getOverlappingDaysError: PropTypes.func,
};

const mapStateToProps = ({ contracting }) => ({
  addRateSetStepperComponentIndex: contracting.steppers.get('addRateSetStepper'),
  fieldValues: {
    ...contracting.addRateSetWizard.toJS(),
    productId: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productId']),
    locationId: contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId']),
  },
});

const mapDispatchToProps = dispatch => ({
  goToStep: payload => dispatch({ type: 'CHANGE_STEPPER_WIZARD_STEP', payload }),
  updateFieldValue: payload => dispatch({ type: 'UPDATE_ADD_RATES_FIELD', payload }),
  updateFieldWithKeyPath: payload => dispatch({ type: 'UPDATE_ADD_RATES_FIELD_WITH_KEYPATH', payload }),
  updateDaysOfWeek: payload => dispatch({ type: 'UPDATE_ADD_RATES_DAYSOFWEEK', payload }),
  updateRatesTableCell: payload => dispatch({ type: 'UPDATE_ADD_RATES_RATES_TABLE_CELL_VALUE', payload }),
  calculateRatesTable: () => dispatch({ type: 'CALCULATE_RATES_TABLE' }),
  calculateStandardNonAccomRateTable: () => dispatch({ type: 'CALCULATE_STANDARD_NON_ACCOM_RATES_TABLE' }),
  updateFormData: (...args) => dispatch(updateFormData(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddRateSetStepper);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/add-rates-wizard/add-rateset-wizard.jsx